import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useState, useEffect } from "react"
import Button from "../UI/button/Button"
import * as Style from "./CourseList.module.scss"

const CourseList = ({ info }) => {
  return (
    <div className={Style.wrapper}>
      <h2 className={Style.title}>Какво ще научите в курса</h2>
      <div className={Style.container}>
        {info.imgWithText.map((img_text, index) => {
          return (
            <div index={index} key={index} className={Style.flex_item}>
              <GatsbyImage
                className={Style.image}
                image={getImage(img_text.portrait.localFile)}
                alt="image"
              />
              <div className={Style.text}>{img_text.image_description}</div>
            </div>
          )
        })}
      </div>
      <Button style={Style.btn}>{info.button.button_title}</Button>
    </div>
  )
}

export default CourseList
